<template>
    <v-card flat>
        <v-card-text class="pl-0 pr-0 pb-0">
            <v-row class="mt-n5">
                <v-col cols="auto">
                    <tile-search-date
                        init-type="WEEK"
                        @changed="searchDateChanged"
                        @inited="searchDateInited"
                        ref="date_range_select"
                        :from-day="searchParam.search_start"
                        :to-day="searchParam.search_end"
                    ></tile-search-date>
                </v-col>
                <v-col cols="2">
                    <v-select
                        class="text-h6"
                        single-line
                        :items="selCallResultItems"
                        v-model="searchParam.call_result"
                        label="통화연결 선택"
                        item-text="txt"
                        item-value="val"
                    ></v-select>
                </v-col>
                <v-col cols="2">
                    <v-select
                        class="text-h6"
                        single-line
                        :items="selSearchTypeItems"
                        v-model="searchParam.search_type"
                        label="검색 유형을 선택해 주세요"
                        item-text="txt"
                        item-value="val"
                    ></v-select>
                </v-col>
                <v-col>
                    <v-text-field
                        class="text-h6"
                        v-model="searchParam.search_text"
                        @keyup.enter="doSearch(1)"
                    ></v-text-field>
                </v-col>
                <v-col class="d-flex align-center">
                    <tile-search-button @click="doSearch(1)" class="mx-2" style="float:left;"></tile-search-button>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right mt-n5" style="font-size:20px; color:#555555;">통화량 : {{ this.$options.filters.number(totalCount) }} 건</v-col>
            </v-row>
            <v-card flat class="mt-4">
                <v-simple-table class="border-table">
                    <template v-slot:default>
                        <thead>
                        <tr style="background-color:#F4F6F8; height:39px; color:#333333; font-weight:600;">
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">발신일시</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">발신자</th>
                            <th colspan="2" class="text-center text-h6 border-th-bottom">수신자</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">통화결과</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">통화시간</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom" v-if="recordAccYn === 'Y'">녹취</th>
                        </tr>
                        <tr style="background-color:#F4F6F8; height:39px; color:#333333; font-weight:600;">
                            <th class="text-center text-h6">이름(표시명)</th>
                            <th class="text-center text-h6">수신번호</th>
                        </tr>
                        </thead>
                        <tbody style="color:#555555;">
                        <tr style="height:68px;" :key="statIdx" v-for="(statItem, statIdx) in statList">
                            <td class="text-center" style="font-size:20px;">{{ statItem.call_start_dt | dateMin }}</td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.user_name }}</td>
                            <td class="text-center" style="font-size:20px;">
                                <template v-if="statItem.cust_name && statItem.cust_name.length !== 0">{{ statItem.cust_name }}</template>
                                <template v-else>
                                    <v-btn outlined color="primary" @click="popupAddrBook(statItem.remote_mdn)">연락처 등록</v-btn>
                                </template>
                                <v-btn outlined color="primary" @click="popupCustMemo(statItem)" class="ml-3">메모({{ statItem.memo_count | number }})</v-btn>
                            </td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.remote_mdn | phoneNum }}</td>
                            <td class="text-center" style="font-size:20px;">{{ callResultText(statItem.call_result) }}</td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.call_billsec_min | number }} 분</td>
                            <td class="text-center" style="font-size:20px;" v-if="recordAccYn === 'Y'">
                                <v-btn small v-if="recordAccYn === 'Y' && statItem.record_yn === 'Y' && statItem.record_result === 'DONE' && statItem.record_cont_seqno > 0 && statItem.play_yn === 'Y'"
                                       @click="downloadRecord(statItem)" outlined color="green" style="font-weight: 600; font-size: 14px;">다운로드
                                </v-btn>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr style="height:69px;" v-if="!statList || statList.length === 0">
                            <td class="text-center" style="font-size:20px;" colspan="7">조회된 결과가 없습니다</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
            <v-row class="mt-4">
                <v-col cols="2" class="text-left">
                    <v-btn v-on:click="downloadExcel" :loading="excelLoading">DOWNLOAD</v-btn>
                </v-col>
                <v-col cols="10" class="text-right">
                    <tile-paging :pageNo="searchParam.page_no" :totalPageCount="totalPageCount" @goPage="doSearch"></tile-paging>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import {mapGetters, mapState} from 'vuex'
import svcHistApi from '@/api/svc_hist'


export default {
    name: 'stats_recv_call_list',
    components: {
        'TilePaging': () => import('@/components/common/tile_paging.vue'),
        'TileSearchDate': () => import('@/components/common/tile_search_date.vue'),
        'TileSearchButton': () => import('@/components/common/tile_search_button.vue'),
    },
    data: () => ({
        searchParam: {
            search_start: '',
            search_end: '',
            call_result: '',
            search_type: 'REMOTE_MDN_ENC',
            search_text: '',
            page_no: 1,
            page_size: 25
        },
        selCallResultItems: [
            {txt: '통화결과: 전체', val: ''},
            {txt: '통화결과: 통화', val: 'SUCC'},
            {txt: '통화결과: 미응답', val: 'MISS'},
            {txt: '통화결과: 수신거부', val: 'REJECT'},
            {txt: '통화결과: 통화중', val: 'INUSE'}
        ],
        selSearchTypeItems: [
            {txt: '검색유형: 수신번호', val: 'REMOTE_MDN_ENC'},
            {txt: '검색유형: 수신자명', val: 'CUST_NAME'}
        ],
        initFlags: {'search_date': false},
        excelLoading: false,
    }),
    created() {
        this.$store.commit('layoutFlag', true)
        this.$store.commit('menuId', 'svc_hist_send')

        let lastMenuId = this.$store.getters['lastMenuId']
        if (lastMenuId === 'svc_hist_send' && this.curSearchParam) {
            Object.assign(this.search, this.curSearchParam)
        }
    },
    computed: {
        ...mapGetters({
            recordAccYn: 'login/getRecordAccYn'
        }),
        ...mapState('svc_hist_send', {
            curSearchParam: state => state.searchParam,
            totalCount: state => state.totalCount,
            statList: state => state.statList,
        }),
        totalPageCount() {
            if (this.totalCount === 0) {
                return 0
            }
            let pageSize = (this.searchParam && this.searchParam.page_size) ? this.searchParam.page_size : 25
            return Math.floor(this.totalCount / pageSize) + (((this.totalCount % pageSize) > 0) ? 1 : 0)
        },
        isLoaded() {
            return !!this.statList
        }
    },
    methods: {
        searchDateInited(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
            this.initFlags['search_date'] = true
            this.doSearch()
        },
        searchDateChanged(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
        },
        doSearch(no) {
            if (no) {
                this.searchParam.page_no = no
            }
            if (!this.initFlags.search_date) {
                return
            }

            this.$store.dispatch('svc_hist_send/getStatList', {
                searchParam: this.searchParam,
                scb: () => {
                },
                fcb: () => {
                },
                va: this
            })
        },
        callResultText(c) {
            const statusMap = {'SUCC': '통화', 'MISS': '미응답', 'REJECT': '수신거부', 'INUSE': '통화중'}
            return statusMap[c] || c

        },
        downloadRecord(item) {
            if (!item?.record_cont_seqno) return

            let va = this
            va.$store.dispatch('openConfirm', {
                message: '녹취 데이터를 다운로드 하시겠습니까?',
                va: va,
                okCb: function () {
                    svcHistApi.downloadRecord({seq: item.record_cont_seqno, tm: item.call_start_dt, mdn: item.remote_mdn})
                }
            })
        },
        downloadExcel() {
            let va = this
            va.$store.dispatch('openConfirm', {
                message: '발신 통화 이력 목록을 엑셀 파일로 다운로드하시겠습니까?',
                va: va,
                okCb: function (va) {
                    va.excelLoading = true
                    svcHistApi.downloadExcel({search_start: va.searchParam.search_start, search_end: va.searchParam.search_end, call_type: 'OTB_SEND'},
                        (va) => {
                            va.excelLoading = false
                            // SUCC
                            va.$store.dispatch('openAlert', {message: '엑셀 파일이 다운로드 되었습니다',})
                        }, (err, va) => {
                            va.excelLoading = false
                            // FAIL
                            va.$store.dispatch('openAlert', {message: '엑셀 파일이 다운로드를 실패 했습니다',})
                        }, va
                    )
                }
            })
        },
        popupAddrBook(custMdn) {
            this.$store.dispatch('openAddrBook',
                {
                    'addrBook': {
                        'cust_mdn': custMdn,
                        'pageMode': 'add_with_mdn'
                    },
                    'okCb': (va) => {
                        va.doSearch()
                    },
                    'va': this
                }
            )
        },
        popupCustMemo(item) {
            this.$emit('open-memo', {'cust_seqno': item.cust_seqno, 'cust_mdn': item.remote_mdn, 'cust_name': item.cust_name})
        },
        refresh() {
            this.doSearch()
        }
    }
}
</script>